import React, { Component } from "react";
import { observer } from 'mobx-react';
import Chart from "react-apexcharts";

const TimeColumChart = observer(class TimeColumChart extends Component {
  constructor(props) {
    super(props);

   this.state = {
          
            series: [{
              name: 'Chats',
              data: this.props.store.performanceData.chartsCount
            },
            //  {
            //   name: 'Missed Chats',
            //   data: this.props.store.performanceData.missedchartsCount
            // }
          ],
            options: {
              chart: {
                type: 'bar',
                height: 350,
                stacked: true,

                toolbar: {
                  show: true,
                  offsetX: 0,
                  offsetY: 0,
                  tools: {
                    download: false,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    // reset: true | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: []
                  },
                },
                zoom: {
                  enabled: true
                }
              },
              responsive: [{
                breakpoint: 480,
                options: {
                 
                }
              }],
              plotOptions: {
              
              },

              dataLabels: {
                enabled: false
              },
              tooltip: {
                theme:"dark",
                position:"topleft",
                x : {show: false},
              },
              xaxis: {
                type: 'categorys',
                categories: this.props.store.performanceData.chartsDate,
                  labels: {
                    datetimeFormatter: {
                      year: 'yyyy',
                      month: 'MMM \'yy',
                      day: 'dd MMM',
                      hour: 'HH:mm'
                    }
                  }
                
              },
              colors: ['#008ffb', '#d11b1b'],

              yaxis: {
                type:'time',
                show:true,
                min:0,
                forceNiceScale: true,
                labels: {
                  formatter: function (value) {
                    return value ;
                  }
                },
                
               },
              fill: {
                colors: ['#008ffb', '#d11b1b'],
                opacity: 1
              }
            },
          
          
          };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart">
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              width="900"
              height="300px"
            />
          </div>
        </div>
      </div>
    );
  }
})

export default TimeColumChart;